module.exports = __webpack_public_path__ + "img/work2022-euro-mis.e0f406ea.png";